import { selectors as current } from '../current';
import * as user from './index';
import * as move from '../move';
import { matchers } from '../http-request';

const { isRequestResultSuccessFor } = matchers.core;

export function UserEpic() {
  return (action, { dispatch, getState }) => {
    const state = getState();

    if (isRequestResultSuccessFor(move.actions.isCreate)(action)) {
      // Whenever we create a new move we need to update the user
      // so we get the latest current_move_id
      dispatch(user.actions.singleton(current.user(state).id(state)).read());
    }
  };
}
